import { useEffect, useState } from "react";
import { useAuth } from "../utils/AuthContext";


export const usePathologist = () => {
 const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const { user, loading } = useAuth();
  const [isPathologist, setIsPathologist] = useState(false);
  const [pathologistLoading, setPathologistLoading] = useState(true);

useEffect(() => {
  // console.log("usePathologist User:", user);
  if (!loading) {
    if (user) {
      setIsPathologist(user.role === "pathologist");
      setIsAdmin(user.role === "admin");
      setIsSuperAdmin(user.role === "superadmin");
    } else {
      setIsPathologist(false);
      setIsAdmin(false);
      setIsSuperAdmin(false);
    }
    setPathologistLoading(false);
  }
}, [user, loading]);

  return { isPathologist,isAdmin, isSuperAdmin, isLoading: loading || pathologistLoading };
};